jQuery(document).ready(function($) {
    $(".lazy-youtube").on("click", function () {
	    var $el = $(this);
	    var videoId = $el.data("video-id");
	    const iframe = $("<iframe>", {
	      src: `https://www.youtube.com/embed/${videoId}?autoplay=1&modestbranding=1&controls=1&playlist=${videoId}&rel=0`,
	      frameborder: "0",
	      allowfullscreen: true,
	      allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
	      class: "position-absolute h-100 w-100"
	    });
	    $el.empty().append(iframe);
	});
});

